import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { DatePipe, NgOptimizedImage } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { TranslateModule, provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import { TreeModule } from 'primeng/tree';
import { PanelModule } from 'primeng/panel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { serverUrlToken, versionToken } from 'shared';
import { version } from 'package.json';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { routes } from './app/app-routing.module';
import { PathInterceptor } from './app/interceptors/path.interceptor';
import { SortByNamePipe } from './app/pipes/sort-company-by-name.pipe';
import { SortByValuePipe } from './app/pipes/sort-by-value.pipe';
import { provideMsalAuth } from './app/msal/msal-auth.config';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      NgbModule,
      BrowserModule,
      ReactiveFormsModule,
      NgSelectModule,
      FormsModule,
      CdkStepperModule,
      TranslateModule,
      OverlayModule,
      NgxDropzoneModule,
      NgJsonEditorModule,
      PolymorpheusModule,
      NgOptimizedImage,
      TreeModule,
      PanelModule,
      ProgressSpinnerModule,
      ToggleSwitchModule,
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader(),
    }),
    DatePipe,
    SortByNamePipe,
    SortByValuePipe,
    { provide: serverUrlToken, useValue: environment.serverUrl },
    { provide: versionToken, useValue: version },
    ...provideMsalAuth(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PathInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes),
  ],
}).catch((err) => console.error(err));
